import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitShowQuota = createSelector(
  [selectFinancialCockpitState],
  ({ showQuota }) => showQuota
)
